module.exports = __webpack_public_path__ + "img/lihe.2f381bee.png";